module.exports = "pegasus_template/assets/tech/email1-gallery-img2.png";